// Loader.jsx
import React from "react";

const N_C_loader = () => {
  return (
    <div className="ncloader-wrapper">
      <div className="ncspinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default N_C_loader;
